"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExposureDom = void 0;
/**
 * 捕获当前可视窗口展示dom节点，可用作曝光统计
 */
var tools_1 = require("./tools");
var getExposureDom = function (element, callback, options) {
    if (options === void 0) { options = {}; }
    var elementTypeIsString = Object.prototype.toString.apply(element).toLowerCase() == "[object string]";
    var elementTypeIsNodeList = Object.prototype.toString.apply(element).toLowerCase() ==
        "[object nodelist]";
    if (!element || (!elementTypeIsString && !elementTypeIsNodeList)) {
        return false;
    }
    var elementList = elementTypeIsString
        ? document.querySelectorAll(element)
        : element;
    var _a = options.threshold, threshold = _a === void 0 ? 0 : _a, _b = options.wrap, wrap = _b === void 0 ? window : _b, _c = options.time, time = _c === void 0 ? 300 : _c, _d = options.isRealTime, isRealTime = _d === void 0 ? false : _d;
    var clientH = tools_1.getClientHeight();
    var flag = elementList.length > 0 || (isRealTime && elementTypeIsString);
    flag &&
        tools_1.scrollEndHandler(function () {
            elementTypeIsString &&
                isRealTime &&
                (elementList = document.querySelectorAll(element));
            for (var i = elementList.length - 1; i >= 0; i--) {
                var dom = elementList[i];
                var _a = dom.getBoundingClientRect(), top_1 = _a.top, h = _a.height;
                if (Math.abs(top_1) < clientH && tools_1.accAdd(Math.abs(top_1), threshold) < h) {
                    callback(dom);
                }
            }
        }, { el: wrap, time: time });
};
exports.getExposureDom = getExposureDom;
